import EstimateDetailsContainer from "@legacy/estimates/EstimateDetailsContainer"

import useHasAccess from "@hooks/useHasAccess"
import useSlugExtractor from "@hooks/useSlugExtractor"
import useToastQueue from "@hooks/useToastQueue"

import { TopBar } from "@organisms"

import { AppFrame } from "@templates"

import { ESTIMATES_ROUTES } from "@routes/estimates"

import { PERMISSION_LEVEL } from "@constants/permissionLevel"

export default function EstimateDetails() {
    const [listRoute] = useSlugExtractor([ESTIMATES_ROUTES.LIST])
    const { addToastToQueue } = useToastQueue()
    const { hasPermission } = useHasAccess()

    const backDestination = hasPermission("estimates_list_permission", PERMISSION_LEVEL.FULL) ? listRoute : undefined

    return (
        <AppFrame.Root pageId="EstimateDetails" navigationType="inner">
            <TopBar.Root>
                <TopBar.Header>
                    <TopBar.TopBarHeaderStart>
                        <TopBar.PageInnerTitle label="Estimate Details" backDestination={backDestination} />
                    </TopBar.TopBarHeaderStart>
                </TopBar.Header>
            </TopBar.Root>
            <AppFrame.PageContent>
                <EstimateDetailsContainer addToastToQueue={addToastToQueue} />
            </AppFrame.PageContent>
        </AppFrame.Root>
    )
}
